import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getViewGroup = (params) => {
    return axios.get(`${backendHost}/api/admin/cashiers/groups/view`, {params});
};

export {
    getViewGroup
}